const GetAllMembersInTeamTerm_query = `
  query($teamTermId: Int!) {
    getAllMembersInTeamTerm(teamTermId: $teamTermId) {
      teamTermMemberId
      teamTermId{
        teamTermId
        termId
        {
          name
        }
      }
      userId{
        id
        username
        firstName
        lastName
      }
      roleId{
        roleId
        roleName
      }
      userTypeId{
        userTypeId
        typeName
      }    
      note
      completed
      noteUpdateDate
      noteUpdateBy
      createDate
      createBy
      updateDate
      updateBy
    }
  }
`;

const GetTermTeamMember_query = `
  query($teamTermMemberId: Int!) {
    getTermTeamMember(teamTermMemberId: $teamTermMemberId) {
      teamTermMemberId
      teamTermId{
        teamTermId

        termId
          {
            name
           }
        teamId
          {
            name
          }
      }
      userId{
        id
        username
        firstName
        lastName
      }
      roleId{
        roleId
        roleName
      }
      userTypeId{
        userTypeId
        typeName
      }    
      note
      completed
      applyNextTerm
      available
      noteUpdateDate
      noteUpdateBy
      createDate
      createBy
      updateDate
      updateBy
    }
  }
`;

const DeleteTeamTermMember_mutate = `
    mutation delete_team_term_member($teamTermMemberId: Int!) {
      deleteTeamTermMember(teamTermMemberId: $teamTermMemberId) {
        response
      }
    }
`;

const CreateTeamTermMember_mutate = `
    mutation createTeamTermMember(
      $teamTermId: Int!
      $userId: Int! 
      $roleId: Int!
      $userTypeId: Int!    
      ) {
      createTeamTermMember(
        teamTermId: $teamTermId,
        userId: $userId,
        roleId: $roleId,
        userTypeId: $userTypeId,
         ) {
        teamTermMember
        {
          teamTermMemberId
          teamTermId
          {
            teamTermId
          }
          userId{
            id
            firstName
            lastName
          }
          roleId{
            roleId
            roleName
          }
          userTypeId{
            userTypeId
            typeName
          }          
          createDate
          updateDate                
        }
      }
    }
`;

const EditTeamTermMember_mutate = `
  mutation editTeamTermMember( 
    $teamTermMemberId:Int!     
    $roleId: Int!            
    ) {
    editTeamTermMember(
      teamTermMemberId: $teamTermMemberId,        
      roleId: $roleId,     
      ) {
      teamTermMember
      {
        teamTermMemberId
        teamTermId{
          teamTermId
        }
        userId{
          id
          firstName
          lastName
        }
        roleId{
          roleId
          roleName
        }
        userTypeId{
          userTypeId
          typeName
        }          
        createDate
        updateDate
      }
    }
  }
`;

const FindAssignedTeams_query = `
query($userId: Int!) {
  findAssignedTeams(userId: $userId) 
  {
    teamTermMemberId
    teamTermId
    {
      teamTermId
      teamId
      {
        teamId
        name
      }
      termId{
        termId
      }     
    }
    userId{
      id
      firstName
      lastName
    }
    roleId
    {
      roleId
      roleName
    }
    
  }
}
`;

const EditTeamTermMemberNotes_mutate = `mutation editTeamTermMemberNotes(
      $teamTermMemberId:Int!, 
      $notes: String!,
      $completed: Boolean,
      $available: Boolean,
      $applyNextTerm: Boolean,
      ){
  editTeamTermMemberNotes(
      teamTermMemberId: $teamTermMemberId, 
      notes: $notes,
      completed: $completed,
      available: $available
      applyNextTerm: $applyNextTerm
      ){
    teamTermMember{
      teamTermMemberId
      note
    }
  }
}`;

module.exports = {
  GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY: GetAllMembersInTeamTerm_query,
  DELETE_TEAM_TERM_MEMBER_MUTATION: DeleteTeamTermMember_mutate,
  CREATE_TEAM_TERM_MEMBER_MUTATION: CreateTeamTermMember_mutate,
  EDIT_TEAM_TERM_MEMBER_MUTATION: EditTeamTermMember_mutate,
  FIND_ASSIGNED_TEAMS_QUERY: FindAssignedTeams_query,
  GET_TERM_TEAM_MEMBER_QUERY: GetTermTeamMember_query,
  EDIT_TEAM_TERM_EMBER_NOTES_MUTATION: EditTeamTermMemberNotes_mutate,
};
